export const toCamelCase =	text => text.replace( /(_\w)/g, word => word[ 1 ].toUpperCase() );

export const toPastelCase = text => (
	text ? text[ 0 ].toUpperCase() + toCamelCase( text.slice( 1 ) ) : text
);

export const compareStringsAsc = ( aString, otherString ) => {
	if ( aString < otherString ) { return -1; }
	if ( aString > otherString ) { return 1; }
	return 0;
};

export const applyTrimmed = stringOperation => str => stringOperation( str.trim() );

export const truncateMiddle = ( text, maxLength = 50 ) => {
	if ( text.length <= maxLength ) return text;

	const charsToShow = maxLength - 3; // Reserve 3 chars for "..."
	const frontChars = Math.ceil( charsToShow / 2 );
	const backChars = Math.floor( charsToShow / 2 );

	return `${text.slice( 0, frontChars )}...${text.slice( -backChars )}`;
};

export const snakeCaseToTitleCase = text => text
	.replace( /_/g, ' ' )
	.replace( /\b\w/g, char => char.toUpperCase() );
